import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Popconfirm,
  Modal,
  Badge,
  Image,
  Tag,
  Row,
  CircularProgress,
} from "@shared/ui";
import { TextField } from "@shared/ui/TextField";
import {
  Influencer,
  InfluencerContact,
  CreateInfluencerRequest,
  IInfluencer,
} from "@shared/lib/types/influencer";
import { useUpdateAgency } from "../lib/hooks/useUpdateAgency";

import { ToastService } from "@shared/lib/services";
// Reuse your existing ContactForm
import styles from "./styles.module.scss";
import { useUpdateNote } from "../lib/hooks/useUpdateNote";
import { useGetAgency } from "../lib/hooks/useGetAgency";
import { Notes } from "@shared/ui/Note/Note";

// import { ReviewList } from "./Reviews/ReviewList";
import { Space, Switch } from "antd";
import { Agency } from "@shared/lib/types/agency";
import { ACCOUNT_STATUS } from "@shared/lib/types";
import { ReviewList } from "./Reviews/ReviewList";
import { AgencyCard } from "./AgencyCard";
import { ContactsList } from "./ContactList/ContactList";
import { AgencyForm } from "./AgencyForm";

export interface AgencyDetailsProps {
  agencyId: string;
}

export const AgencyDetails: React.FC<AgencyDetailsProps> = ({ agencyId }) => {
  const { agency, isFetching } = useGetAgency(agencyId);

  const [isInfluencerModalOpen, setInfluencerModalOpen] = useState(false);

  const { updateAgency, isUpdating, isUpdated } = useUpdateAgency();

  const {
    update: updateNote,
    isUpdating: isUpdatingNotes,
    isUpdated: isUpdatedNotes,
  } = useUpdateNote();

  const handleSubmit = (influencerData: Partial<Agency>) => {
    updateAgency({
      agencyId,
      data: influencerData,
    });
    setInfluencerModalOpen(false);
  };

  useEffect(() => {
    if (isUpdatedNotes) {
      ToastService.success("Agency notes Updated");
    }
  }, [isUpdatedNotes]);
  useEffect(() => {
    if (isUpdatedNotes) {
      ToastService.success("Agency  Updated");
    }
  }, [isUpdated]);

  if (isFetching) {
    return (
      <Row justify={"center"}>
        <CircularProgress />
      </Row>
    );
  }

  if (!agency) return <></>;
  return (
    <div className={styles.container}>
      <Notes
        handleSubmit={(value) => {
          updateNote({
            influencerId: agencyId,
            note: value,
          });
        }}
        isSubmiting={isUpdatingNotes}
        value={agency?.note?.note || ""}
      />
      <AgencyCard
        handleEditClick={() => setInfluencerModalOpen(true)}
        agency={agency}
      />

      <ContactsList users={agency.agencyUsers || []} agencyId={agencyId} />
      <ReviewList reviews={agency.reviews || []} agencyId={agencyId} />

      <div className={styles.card}>
        <Space
          style={{
            justifyContent: "space-between",
            width: "100%",
            alignItems: "center",
          }}
        >
          <div>
            <div className={styles.permItemTitle}>Deactivate</div>
            <div className={styles.permItemDesc}>Mark as inactive</div>
          </div>
          <Switch
            checked={agency.status === ACCOUNT_STATUS.INACTIVE}
            onChange={(value) =>
              updateAgency({
                agencyId,
                data: {
                  status: value
                    ? ACCOUNT_STATUS.INACTIVE
                    : ACCOUNT_STATUS.ACTIVE,
                },
              })
            }
            loading={isUpdating}
          />
        </Space>
      </div>
      <Modal
        title="Update Agency"
        open={isInfluencerModalOpen}
        onCancel={() => setInfluencerModalOpen(false)}
        footer={null}
        destroyOnClose
      >
        <AgencyForm
          initialValues={agency}
          isSubmitting={isUpdating}
          onSubmit={handleSubmit}
        />
        {/* <InfluencerUpdateForm
          initialValues={influencer}
          isSubmitting={isUpdating}
          onSubmit={handleSubmit}
          initialCategories={categories}
        /> */}
      </Modal>
    </div>
  );
};
